import { Controller } from "@hotwired/stimulus"
import { NavigationHelper } from "~/helpers/navigation_helper"

export default class extends Controller {
  static targets = ["detail", "loader", "showModal", "editModal", "sourcesList"]

  initialize() {
    // in case the user is on a Turbo preview of the page,
    // don't fetch a message and don't reset counters
    if (NavigationHelper.pageIsPreview()) { return }

    // To prevent any risk of modal content being reused from one message
    // detail to another, we empty their content when the modal is hidden.
    this.resetMessageDetailsOnHide()

    this.initializeOutreachIndex()
  }

  initializeOutreachIndex() {
    if ($("#inbox-list").length == 0) { return }

    // opens the detail of the first item of the list
    this.showDetail(null, $("#inbox-list li:first-child .inbox-item__link").data("id"))
  }

  showPopup(e) {
    var message = $(e.target).closest(".message-preview")

    App.modal($(this.showModalTarget), "show")

    fetch(`/messages/${message.data("id")}`, { credentials: "same-origin" })
      .then(response => {
        if (response.ok) {
          return response.text()
        }

        throw new Error(response.statusText)
      })
      .then(html => {
        // Add the recipient information in the modal header
        $("#message-detail-recipient").text(message.data("message-detail-recipient-address"))

        // Display the content of the modal
        $("#message-detail").html(html)
        $("#message-detail").show()
        $(".modal-loading").hide()
        App.tooltip("#message-detail [data-bs-toggle='tooltip']")
        App.popover("#message-detail [data-bs-toggle='popover']")

        // load the reply if it exists
        if ($("#reply-content").length) {
          this.loadReply(message.data("id"))
        }

        App.modalEvent($(this.showModalTarget), "hidden.bs.modal", function () {
          $(".modal-loading").show()
        })
      })
      .catch(error => {
        App.modal($(this.showModalTarget), "hide")
        App.displayFlash("danger", `The email couldn't be retrieved (${error}).`)
      })
  }

  editPopup(e) {
    var message = $(e.target).closest(".message-preview")
    var _this = this

    App.modal($(this.editModalTarget), "show")

    fetch(message.data("url"), { credentials: "same-origin" })
      .then(response => {
        if (response.ok) {
          return response.text()
        }

        throw new Error(response.statusText)
      })
      .then(html => {
        $(".message-detail").html(html)
        $(".message-detail").show()
        $(".modal-loading").hide()

        App.modalEvent($(this.editModalTarget), "hidden.bs.modal", function () {
          $(".modal-loading").show()
        })
      })
      .catch(error => {
        App.modal($(this.editModalTarget), "hide")
        App.displayFlash("danger", `The email couldn't be retrieved (${error}).`)
      })
  }

  toggleSources(e) {
    $(e.target).find(".far").toggleClass("fa-angle-up").toggleClass("fa-angle-down")
    $(this.sourcesListTarget).slideToggle(200)
  }

  templateSelected() {
    var template = $("select#template-field").find(":selected")
    $("#subject-field").val(template.data("subject"))
    document.querySelector("trix-editor").editor.loadHTML(template.data("body"))
  }

  showDetail(e, id) {
    var _this = this

    $(_this.detailTarget).hide()
    $(_this.loaderTarget).show()
    $("#inbox-list .inbox-item__link").removeClass("selected")

    if (typeof id == "undefined") {
      var id = e.currentTarget.dataset.id
      e.currentTarget.classList.add("selected")
    } else {
      $(`#inbox-list .inbox-item__link[data-id='${id}']`).addClass("selected")
    }

    fetch(`/messages/${id}`, { credentials: "same-origin" })
      .then(response => {
        if (response.ok) {
          return response.text()
        }

        throw new Error(response.statusText)
      })
      .then(html => {
        $(_this.detailTarget).show()
        $(_this.detailTarget).html(html)
        App.tooltip(_this.detailTarget.querySelectorAll("[data-bs-toggle='tooltip']"))
        $(_this.loaderTarget).hide()
        $(`li[data-id='${id}']`).removeClass("unseen")

        // load the reply if it exists
        if ($("#reply-content").length) {
          this.loadReply(id)
        }
      }).catch(error => {
        App.displayFlash("danger", `The email couldn't be retrieved (${error}).`)
      })
  }

  deployEventsList(e) {
    var container = $(`#message-activity-${$(e.target).data("message-id")}`)
    container.find(`#${$(e.target).data("event-type")}-event-details`).slideDown(200)
    container.find(`#see-${$(e.target).data("event-type")}-events`).hide()
    container.find(`#hide-${$(e.target).data("event-type")}-events`).show()
  }

  hideEventsList(e) {
    var container = $(`#message-activity-${$(e.target).data("message-id")}`)
    container.find(`#${$(e.target).data("event-type")}-event-details`).slideUp(200)
    container.find(`#hide-${$(e.target).data("event-type")}-events`).hide()
    container.find(`#see-${$(e.target).data("event-type")}-events`).show()
  }

  loadReply(id) {
    fetch(`/messages/${id}/reply`, { credentials: "same-origin" })
      .then(response => {
        if (response.ok) {
          return response.text()
        }

        throw new Error(response.statusText)
      })
      .then(html => {
        $("#reply-content").html(html)
        App.tooltip("#reply-content [data-bs-toggle='tooltip']")
      })
      .catch(error => {
        App.displayFlash("danger", `The reply couldn't be retrieved (${error}).`)
      })
  }

  resetMessageDetailsOnHide() {
    if (this.hasEditModalTarget) {
      App.modalEvent($(this.editModalTarget), "hidden.bs.modal", function () {
        $(".message-detail").html("")
      })
    }

    if (this.showEditModalTarget) {
      App.modalEvent($(this.showModalTarget), "hidden.bs.modal", function () {
        $("#message-detail").html("")
      })
    }
  }
}
